module.exports = __webpack_public_path__ + "media/images/categories/headers/business-innovation-404756a8ace9fd1da4a65cff284fde68.jpg";